import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "./auth";
import { Button } from "@mui/material";

import "./App.scss";
import "./i18n/config";
import Dashboard from "./pages/Dashboard";
import Loader from "./components/Loader";
import Profile from "./pages/Profile";
import Resources from "./pages/Resources";
import Dataplanes from "./pages/Dataplanes";
import Database from "./pages/Database";
import DatabaseDetails from "./pages/Database/details";
import UI from "./pages/UI";
import Clusters from "./pages/Clusters";
import AccountsLayout from "./pages/Accounts";
import Simulators from "./pages/Simulators";
import Users from "./pages/Users";
import Roles from "./pages/Roles";
import Permissions from "./pages/Permissions";
import { setTokenFetcher } from "./services/api";
import { setAuthTokenFetcher } from "./services/auth.service";

import "./App.scss";
import MLDeploymentsLayout from "./pages/MLDeployments";
import UserGroups from "./pages/UserGroups";
import Sheet from "./pages/SetupData";
import Pipelines from "./pages/Pipelines";
import PipelineDetails from "./pages/Pipelines/details";
import { useUserContext } from "./components/UserProvider";
import { isPipelinesEnabled } from "./utils/config";

const App = () => {
  const {
    isAuthenticated,
    isLoading,
    error,
    logout,
    login,
    getToken,
  } = useAuth();

  useEffect(() => {
    // Initialize the application permissions
    isAuthenticated && getToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  // Use this to pass the token fetcher to api.ts and auth service
  useEffect(() => {
    setTokenFetcher(() => getToken());
    setAuthTokenFetcher(() => getToken());
  }, [getToken, isAuthenticated]);

  if (error) {
    return (
      <div className="error-container">
        <div className="row text-center">
          <div className="error-item">Controlrooms</div>
          <div className="error-item">{error.message}</div>
          <Button
            color="primary"
            onClick={() => {
              logout({ returnTo: window.location.origin });
            }}
            style={{
              marginTop: "20px",
            }}
          >
            Take me to login.
          </Button>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    login();
  }

  return <div className="App">{isAuthenticated ? <AppRoutes /> : <></>}</div>;
};

export default App;

const AppRoutes = () => {
  const { userRoles } = useUserContext();

  return (
    <Dashboard>
      <Routes>
        {(userRoles?.includes("SETUP_DATA")|| !userRoles?.includes("ADMIN")) && (
          // Show only Sheet for SETUP_DATA role without ADMIN privileges
          <Route path="/Sheet" element={<Sheet />} />
        )}
        {userRoles?.includes("ADMIN") && (
          <>
            <Route path="/" element={<Resources />} />
            <Route path="/Sheet" element={<Sheet />} />
            <Route path="/Dataplanes" element={<Dataplanes />} />
            <Route path="/Database" element={<Database />} />
            <Route path="/Database/:dbName" element={<DatabaseDetails />} />
            <Route path="/Simulators" element={<Simulators />} />
            <Route path="/Accounts" element={<AccountsLayout />} />
            <Route path="/Users" element={<Users />} />
            <Route path="/Roles" element={<Roles />} />
            <Route path="/Permissions" element={<Permissions />} />
            <Route path="/Clusters" element={<Clusters />} />
            <Route path="/UI" element={<UI />} />
            <Route path="/Profile" element={<Profile />} />
            <Route path="/ML-Deployments" element={<MLDeploymentsLayout />} />
            <Route path="/User-Groups" element={<UserGroups />} />
            {isPipelinesEnabled() && (
              <>
                <Route path="/Pipelines" element={<Pipelines />} />
                <Route path="/Pipelines/:envId" element={<PipelineDetails />} />
              </>
            )}
          </>
        )}
      </Routes>
    </Dashboard>
  );
};
